import React, { useEffect, useRef, useState } from "react";
import L from "leaflet";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tree } from 'primereact/tree';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster";
import chitradurgaGeoJSON from "./Chitradurgaexport.json";
import api from "../../api";
import { useSelector, useDispatch } from 'react-redux';
import { fetchDashboardData } from '../DashboardTabs/DashboardSlice';
import { loadDashboardFromStorage } from "../DashboardTabs/DashboardSlice";

const DashboardSection = () => {
  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const mapInstanceRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [mapData, setMapData] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [showLocationFilters, setShowLocationFilters] = useState(false);
  const [selectedTaluks, setSelectedTaluks] = useState([]);
  const fldRoleCode = sessionStorage.getItem("RoleCode");
  const [selectedVillages, setSelectedVillages] = useState([]);
  const [villageSearchTerm, setVillageSearchTerm] = useState('');
  const [zoomLevel, setZoomLevel] = useState(10);
  const [maxZoom, setMaxZoom] = useState(18);
  const [showDeterminantFilters, setShowDeterminantFilters] = useState(false);
  const [activeDeterminantFilters, setActiveDeterminantFilters] = useState({});
  const [determinantSearchTerm, setDeterminantSearchTerm] = useState('');
  // const [isDeterminantLoading, setIsDeterminantLoading] = useState(false);
  const [minZoom, setMinZoom] = useState(9);
  const { data, loading, error, lastFetched } = useSelector(state => state.dashboard);
  const [activeFilters, setActiveFilters] = useState({
    education: true,
    healthcare: true,
    water: true,
    community: true,
    transport: true,
    waste: true,
    market: true,
    religious: true,
    recreation: true
  });
   const [filteredDeterminantData, setFilteredDeterminantData] = useState({
    behavioral: null,
    social: null,
    health: null,
    environmental: null,
    healthService: null
  });
  const [expandedDeterminantSections, setExpandedDeterminantSections] = useState({
    social: false,
    behavioral: false,
    health: false,
    environmental: false,
    healthService: false,
    age: false,
    gender: false
  });
  const [activeAgeFilters, setActiveAgeFilters] = useState({
    "0-5": false,
    "6-14": false,
    "15-19": false,
    "20-29": false,
    "30-39": false,
    "40-49": false,
    "50-59": false,
    "60+": false
  });
  const [activeGenderFilters, setActiveGenderFilters] = useState({
    "Male": true,
    "Female": true
  });

  // Taluk and Village data structure
  const talukVillageData = {
    "Chitradurga": [
      "Jodichikkenahalli",
      "Kyadigere",
      "Hale Dyamavvana Halli",
      "J J Hatti",
      "Kasavanahalli",
      "Ennegere",
      "Gonur",
      "Venkateshwara Badavane",
      "Gandhi Nagara",
      "Kasavarahatti"
    ],
    "Hiriyur": [
      "Hosakere",
      "Halagaladdi",
      "Khandenahalli Palya",
      "Benakanahalli",
      "P D Kote",
      "Adivala Farm",
      "T G Colony",
      "Bovi Colony",
      "Adivala",
      "Gollarahatti"
    ],
    "Holalkere": [
      "Kolalu",
      "Echaghatta",
      "T-Nulenuru",
      "Kereyagalahalli",
      "Halenahalli",
      "Hulikere",
      "Kudineer Katte",
      "Talya",
      "Tekalarvatti",
      "Holalkere_Gollarahatti"
    ]
  };


  // Get all villages for selected taluks
  const getVillagesForSelectedTaluks = () => {
    return selectedTaluks.flatMap(taluk => talukVillageData[taluk] || []);
  };

  // Filter villages based on search term
  const filteredVillages = villageSearchTerm
    ? getVillagesForSelectedTaluks().filter(village =>
      village.toLowerCase().includes(villageSearchTerm.toLowerCase())
    )
    : getVillagesForSelectedTaluks();

  const markerLayersRef = useRef({
    education: L.layerGroup(),
    healthcare: L.layerGroup(),
    water: L.layerGroup(),
    community: L.layerGroup(),
    transport: L.layerGroup(),
    waste: L.layerGroup(),
    market: L.layerGroup(),
    religious: L.layerGroup(),
    recreation: L.layerGroup(),
    district: L.layerGroup()
  });
  const markerClustersRef = useRef({
    education: L.markerClusterGroup(),
    healthcare: L.markerClusterGroup(),
    water: L.markerClusterGroup(),
    community: L.markerClusterGroup(),
    transport: L.markerClusterGroup(),
    waste: L.markerClusterGroup(),
    market: L.markerClusterGroup(),
    religious: L.markerClusterGroup(),
    recreation: L.markerClusterGroup(),
    health: L.markerClusterGroup(),
    environmental: L.markerClusterGroup(),
    healthService: L.markerClusterGroup()
  });

  // Fix for default markers in Leaflet
  useEffect(() => {
    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });
  }, []);



  useEffect(() => {
    if (data) {
      console.log("data...--", data)
      
      // Filter the determinant data
      const filteredBehavioral = filterYesNoDeterminants(data?.["behavioural_and_cultural_determinants"]?.members_data_behavioural_determinats);
      const filteredSocial = filterYesNoDeterminants(data?.["dashboard_social_determinations"]?.household_data_social_determinants);
      const filteredHealth = filterYesNoDeterminants(data?.["health_status_of_the_population_data"]?.members_data_health_status_of_the_population);
      const filteredEnvironmental = filterYesNoDeterminants(data?.["environmental_determinants_data"]?.household_data_environmental_determinants);
      const filteredHealthService = filterYesNoDeterminants(data?.["health_service_determinants_data"]?.household_data_health_service_determinants);
      
      setFilteredDeterminantData({
        behavioral: filteredBehavioral,
        social: filteredSocial,
        health: filteredHealth,
        environmental: filteredEnvironmental,
        healthService: filteredHealthService
      });
      
      setMapData(data?.["section_7_dashboard"]?.household_dashboard_7 || null)
    }
  }, [data]);

  useEffect(() => {
    dispatch(loadDashboardFromStorage());
  }, [dispatch]);


  useEffect(() => {
    if (!mapInstanceRef.current && mapRef.current) {
      initializeMap();
    }

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (mapInstanceRef.current && mapData) {
      addMarkersToMap(mapData);
      addDistrictBoundary();
    }
  }, [mapData, activeFilters, selectedTaluks, selectedVillages, filteredDeterminantData.behavioral, filteredDeterminantData.social, filteredDeterminantData.health, activeDeterminantFilters,activeAgeFilters,activeGenderFilters ]);

  const initializeMap = () => {
    const map = L.map(mapRef.current, {
      center: [14.23, 76.4],
      zoom: 10,
      scrollWheelZoom: true,
      minZoom: 9,
      maxZoom: 18,
      maxBounds: L.latLngBounds([13.5, 75.5], [15.0, 77.5]),
      zoomControl: false   //  disable default zoom (on left)
    });

    //  add zoom control to top right
    L.control.zoom({
      position: 'topright'
    }).addTo(map);

    // Set the min/max zoom from the map instance
    setMinZoom(map.getMinZoom());
    setMaxZoom(map.getMaxZoom());

    // Track zoom level changes
    map.on('zoomend', () => {
      setZoomLevel(map.getZoom());
    });

    // Add base layers
    const osmLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
    });

    const terrainLayer = L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
      attribution: 'Map data: &copy; OpenStreetMap contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a>'
    });

    const satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
      attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
    });

    const baseLayers = {
      "Street Map": osmLayer,
      "Terrain Map": terrainLayer,
      "Satellite": satelliteLayer,
    };

    osmLayer.addTo(map);

    L.control.layers(baseLayers, null, {
      position: 'topright',
      collapsed: false
    }).addTo(map);

    // Initialize all marker clusters
    Object.values(markerClustersRef.current).forEach(cluster => {
      cluster.addTo(map);
    });

    // Add district layer
    markerLayersRef.current.district.addTo(map);

    mapInstanceRef.current = map;
  };


  // Update zoom control buttons based on current zoom level
  useEffect(() => {
    if (mapInstanceRef.current) {
      const zoomInButton = document.querySelector('.leaflet-control-zoom-in');
      const zoomOutButton = document.querySelector('.leaflet-control-zoom-out');

      if (zoomInButton && zoomOutButton) {
        // Dim zoom in button when at max zoom
        if (zoomLevel >= maxZoom) {
          zoomInButton.style.opacity = '0.5';
          zoomInButton.style.cursor = 'not-allowed';
        } else {
          zoomInButton.style.opacity = '1';
          zoomInButton.style.cursor = 'pointer';
        }

        // Dim zoom out button when at min zoom
        if (zoomLevel <= minZoom) {
          zoomOutButton.style.opacity = '0.5';
          zoomOutButton.style.cursor = 'not-allowed';
        } else {
          zoomOutButton.style.opacity = '1';
          zoomOutButton.style.cursor = 'pointer';
        }
      }
    }
  }, [zoomLevel, maxZoom, minZoom]);


  useEffect(() => {
    const allDeterminantKeys = {};

    // Initialize all determinant keys as false (inactive)
    const initializeNestedKeys = (data, prefix) => {
      if (!data) return;

      Object.keys(data).forEach((parentKey) => {
        if (typeof data[parentKey] === 'object' && data[parentKey] !== null) {
          Object.keys(data[parentKey]).forEach((childKey) => {
            allDeterminantKeys[`${prefix}_${parentKey}_${childKey}`] = false;
          });
        } else {
          allDeterminantKeys[`${prefix}_${parentKey}`] = false;
        }
      });
    };

    initializeNestedKeys(filteredDeterminantData.behavioral, 'behavioral');
    initializeNestedKeys(filteredDeterminantData.social, 'social');
    initializeNestedKeys(filteredDeterminantData.health, 'health');
    initializeNestedKeys(filteredDeterminantData.environmental , 'environmental');
    initializeNestedKeys(filteredDeterminantData.healthService, 'healthService');

    setActiveDeterminantFilters(allDeterminantKeys);
  }, [filteredDeterminantData.behavioral, filteredDeterminantData.social, filteredDeterminantData.health, filteredDeterminantData.environmental, filteredDeterminantData.healthService]);


  // Add this function to handle determinant filter changes
  const handleDeterminantFilterChange = (filterName) => {
    setActiveDeterminantFilters(prev => ({
      ...prev,
      [filterName]: !prev[filterName]
    }));
  };


 const filterYesNoDeterminants = (data) => {
  if (!data) return null;
  
  // Return the data as-is without filtering for "1" values
  return data;
};

  // Add this function to select all determinant filters
  const selectAllDeterminantFilters = () => {
    const allActive = {};
    Object.keys(activeDeterminantFilters).forEach(key => {
      allActive[key] = true;
    });
    setActiveDeterminantFilters(allActive);
  };


  // Add this function to remove all determinant filters
  const removeAllDeterminantFilters = () => {
    const allInactive = {};
    Object.keys(activeDeterminantFilters).forEach(key => {
      allInactive[key] = false;
    });
    setActiveDeterminantFilters(allInactive);


  };

  const isPointInDistrict = (lat, lng) => {
    if (!chitradurgaGeoJSON || !chitradurgaGeoJSON.features || !chitradurgaGeoJSON.features[0]) {
      return false;
    }

    const point = [lng, lat]; // GeoJSON uses [lng, lat] format

    // Check if point is inside any of the polygons in the GeoJSON
    const geometry = chitradurgaGeoJSON.features[0].geometry;

    if (geometry.type === "Polygon") {
      return isPointInPolygon(point, geometry.coordinates[0]);
    } else if (geometry.type === "MultiPolygon") {
      return geometry.coordinates.some(polygon =>
        isPointInPolygon(point, polygon[0])
      );
    }

    return false;
  };

  // Ray casting algorithm to check if point is in polygon
  const isPointInPolygon = (point, polygon) => {
    const x = point[0];
    const y = point[1];
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i][0];
      const yi = polygon[i][1];
      const xj = polygon[j][0];
      const yj = polygon[j][1];

      const intersect = ((yi > y) !== (yj > y)) &&
        (x < (xj - xi) * (y - yi) / (yj - yi) + xi);

      if (intersect) inside = !inside;
    }

    return inside;
  };


  const addDistrictBoundary = () => {
    const districtLayer = markerLayersRef.current.district;
    districtLayer.clearLayers();

    // Draw the district outline
    const geoJsonLayer = L.geoJSON(chitradurgaGeoJSON, {
      style: {
        color: '#3498db',
        weight: 3,
        opacity: 1,
        fillOpacity: 0.0
      }
    }).addTo(districtLayer);

    const map = mapInstanceRef.current;
    const bounds = geoJsonLayer.getBounds();

    if (map && bounds.isValid()) {
      map.fitBounds(bounds, { padding: [50, 50] });

      // Get district coordinates and reverse [lng, lat] → [lat, lng]
      const holes = [];
      const geom = chitradurgaGeoJSON.features[0].geometry;

      if (geom.type === "Polygon") {
        holes.push(geom.coordinates[0].map(([lng, lat]) => [lat, lng]));
      }
      else if (geom.type === "MultiPolygon") {
        geom.coordinates.forEach(polygon => {
          holes.push(polygon[0].map(([lng, lat]) => [lat, lng]));
        });
      }

      // Big rectangle covering the world
      const outer = [
        [-90, -180],
        [-90, 180],
        [90, 180],
        [90, -180]
      ];

      // Create mask with outer and hole(s)
      const mask = L.polygon([outer, ...holes], {
        color: "#000",
        weight: 0,
        fillColor: "#000",
        fillOpacity: 0.4,
        interactive: false
      }).addTo(districtLayer);

      geoJsonLayer.bringToFront();
    }
  };

  const toggleFilters = () => {
    const newShowFilters = !showFilters;
    setShowFilters(newShowFilters);

    // Hide other filters when this one opens
    if (newShowFilters) {
      setShowLocationFilters(false);
      setShowDeterminantFilters(false);
    }
  };

  const toggleLocationFilters = () => {
    const newShowLocationFilters = !showLocationFilters;
    setShowLocationFilters(newShowLocationFilters);

    // Hide other filters when this one opens
    if (newShowLocationFilters) {
      setShowFilters(false);
      setShowDeterminantFilters(false);
    }
  };

  const toggleDeterminantFilters = () => {
    const newShowDeterminantFilters = !showDeterminantFilters;
    setShowDeterminantFilters(newShowDeterminantFilters);

    // Hide other filters when this one opens
    if (newShowDeterminantFilters) {
      setShowFilters(false);
      setShowLocationFilters(false);
    }
  };

  const toggleDeterminantSection = (section) => {
    setExpandedDeterminantSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const toggleNestedDeterminantSection = (sectionKey) => {
  setExpandedDeterminantSections(prev => ({
    ...prev,
    [sectionKey]: !prev[sectionKey]
  }));
};

// Add this function to your component to filter out "Yes/No" keys from the UI
const filterDeterminantOptionsWithoutYesNo = (data, prefix) => {
  if (!data) return [];

  const results = [];
  
  Object.keys(data).forEach((parentKey) => {
    // Skip "Yes/No" parent keys entirely
    if (parentKey === 'Yes/No') return;
    
    const parentLabel = parentKey.replace(/_/g, ' ');
    
    // Check if parent matches search
    if (parentLabel.toLowerCase().includes(determinantSearchTerm.toLowerCase())) {
      results.push(parentKey);
    }
    
    // Then check child keys if data has nested structure
    if (typeof data[parentKey] === 'object' && data[parentKey] !== null && !Array.isArray(data[parentKey])) {
      Object.keys(data[parentKey]).forEach((childKey) => {
        // Skip "Yes/No" keys in the UI
        if (childKey === 'Yes/No') return;
        
        const childLabel = childKey.replace(/_/g, ' ');
        const fullPath = `${parentLabel} ${childLabel}`;
        
        // Check if child matches search
        if (childLabel.toLowerCase().includes(determinantSearchTerm.toLowerCase()) || 
            fullPath.toLowerCase().includes(determinantSearchTerm.toLowerCase())) {
          // Only add parent if not already added
          if (!results.includes(parentKey)) {
            results.push(parentKey);
          }
        }
      });
    }
  });
  
  return results;
};

// Update the renderDeterminantOptions function
// Replace your existing renderDeterminantOptions function with this updated version:


const createFilterIcon = (prefix, parentKey, childKey) => {
  // Create a unique hash based on the combination of prefix, parentKey and childKey
  const uniqueString = `${prefix}_${parentKey}_${childKey}`;
  let hash = 0;
  
  for (let i = 0; i < uniqueString.length; i++) {
    hash = uniqueString.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Generate HSL color with fixed saturation and lightness but varying hue
  const hue = Math.abs(hash) % 360;
  const saturation = 70;
  const lightness = 60;
  
  const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  const bgColor = `hsl(${hue}, ${saturation}%, 90%)`;
  
  let emoji;
  switch (prefix) {
    case 'behavioral':
    case 'health':
      emoji = '👤';
      break;
    case 'social':
    case 'environmental':
    case 'healthService':
      emoji = '🏠';
      break;
    default:
      emoji = '🔍';
  }

  return (
    <div style={{
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      backgroundColor: bgColor,
      border: `1px solid ${color}`,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '10px',
      marginRight: '8px',
      flexShrink: 0
    }}>
      {emoji}
    </div>
  );
};




const renderDeterminantOptions = (data, parentKey, prefix) => {
  if (!data[parentKey] || typeof data[parentKey] !== 'object') return null;
  
  return Object.keys(data[parentKey])
    .filter(childKey => {
      return typeof childKey === 'string' && 
             childKey !== 'Yes/No' && 
             !childKey.toLowerCase().includes('yes/no') &&
             !childKey.toLowerCase().includes('yes_no');
    })
    .map((childKey, index) => {
      const itemData = data[parentKey][childKey];
      const itemCount = Array.isArray(itemData) ? itemData.length : 0;
      
      return (
        <div key={`${prefix}_${parentKey}_${childKey}`} className="filter-item" style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            className="filter-checkbox"
            checked={activeDeterminantFilters[`${prefix}_${parentKey}_${childKey}`] || false}
            onChange={() => handleDeterminantFilterChange(`${prefix}_${parentKey}_${childKey}`)}
          />
          {createFilterIcon(prefix, parentKey, childKey)}
          <span className="filter-label">{childKey.replace(/_/g, ' ')}</span>
          <span className="filter-count" style={{ marginLeft: '8px', color: '#555' }}>
            ({itemCount})
          </span>
        </div>
      );
    });
};




const shouldShowAgeGenderSections = () => {
  if (!determinantSearchTerm) return true;
  
  const searchTerm = determinantSearchTerm.toLowerCase();
  const ageTerms = ["age", "years", "0-5", "6-14", "15-19", "20-29", "30-39", "40-49", "50-59", "60+"];
  const genderTerms = ["gender", "male", "female", "sex"];
  
  return ageTerms.some(term => term.includes(searchTerm)) || 
         genderTerms.some(term => term.includes(searchTerm)) ||
         searchTerm.includes('age') ||
         searchTerm.includes('gender');
};


  const handleTalukChange = (talukName) => {
    setSelectedTaluks(prev => {
      if (prev.includes(talukName)) {
        return prev.filter(t => t !== talukName);
      } else {
        return [...prev, talukName];
      }
    });

    // Reset villages when no taluks are selected
    if (selectedTaluks.length === 1 && selectedTaluks[0] === talukName) {
      setSelectedVillages([]);
    }
  };


  const handleGenderFilterChange = (genderKey) => {
  setActiveGenderFilters(prev => ({
    ...prev,
    [genderKey]: !prev[genderKey]
  }));
};

const selectAllGenderFilters = () => {
  setActiveGenderFilters({
    "Male": true,
    "Female": true
  });
};

const removeAllGenderFilters = () => {
  setActiveGenderFilters({
    "Male": false,
    "Female": false
  });
};

const handleAgeFilterChange = (ageKey) => {
  setActiveAgeFilters(prev => ({
    ...prev,
    [ageKey]: !prev[ageKey]
  }));
};

const selectAllAgeFilters = () => {
  setActiveAgeFilters({
    "0-5": true,
    "6-14": true,
    "15-19": true,
    "20-29": true,
    "30-39": true,
    "40-49": true,
    "50-59": true,
    "60+": true
  });
};

const removeAllAgeFilters = () => {
  setActiveAgeFilters({
    "0-5": false,
    "6-14": false,
    "15-19": false,
    "20-29": false,
    "30-39": false,
    "40-49": false,
    "50-59": false,
    "60+": false
  });
};

const getAgeGroup = (age) => {
  const ageNum = parseInt(age);
  if (isNaN(ageNum)) return null;
  
  if (ageNum <= 5) return "0-5";
  if (ageNum <= 14) return "6-14";
  if (ageNum <= 19) return "15-19";
  if (ageNum <= 29) return "20-29";
  if (ageNum <= 39) return "30-39";
  if (ageNum <= 49) return "40-49";
  if (ageNum <= 59) return "50-59";
  return "60+";
};

 
  const handleVillageChange = (villageName) => {
    setSelectedVillages(prev => {
      if (prev.includes(villageName)) {
        return prev.filter(v => v !== villageName);
      } else {
        setVillageSearchTerm('');
        return [...prev, villageName];
      }
    });
  };


  const clearLocationFilters = () => {
    setSelectedTaluks([]);
    setSelectedVillages([]);
    setVillageSearchTerm('');
  };

  const selectAllFacilityFilters = () => {
    setActiveFilters({
      education: true,
      healthcare: true,
      water: true,
      community: true,
      transport: true,
      waste: true,
      market: true,
      religious: true,
      recreation: true
    });
  };

  const removeAllFacilityFilters = () => {
    setActiveFilters({
      education: false,
      healthcare: false,
      water: false,
      community: false,
      transport: false,
      waste: false,
      market: false,
      religious: false,
      recreation: false
    });
  };

  const createCustomIcon = (emoji) => {
    return L.divIcon({
      className: 'custom-marker',
      html: `<div style="
        width: 32px; 
        height: 32px; 
        border-radius: 50%; 
        background-color: white; 
        border: 2px solid #333; 
        box-shadow: 0 2px 8px rgba(0,0,0,0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
      ">${emoji}</div>`,
      iconSize: [32, 32],
      iconAnchor: [16, 16]
    });
  };


const createMemberDataIcon = () => {
  return L.divIcon({
    className: 'custom-marker',
    html: `<div style="
      width: 32px; 
      height: 32px; 
      border-radius: 50%; 
      background-color: #e1edf6ff; 
      border: 2px solid #2980b9; 
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: white;
    ">👤</div>`,
    iconSize: [32, 32],
    iconAnchor: [16, 16]
  });
};

const createHouseholdDataIcon = () => {
  return L.divIcon({
    className: 'custom-marker',
    html: `<div style="
      width: 32px; 
      height: 32px; 
      border-radius: 50%; 
      background-color: #fff6f5ff; 
      border: 2px solid #c0392b; 
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: white;
    ">🏠</div>`,
    iconSize: [32, 32],
    iconAnchor: [16, 16]
  });
};

const createYesNoMemberIcon = (prefix, parentKey, childKey) => {
  // Generate unique color based on the combination
  const uniqueString = `${prefix}_${parentKey}_${childKey}`;
  let hash = 0;
  
  for (let i = 0; i < uniqueString.length; i++) {
    hash = uniqueString.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  const hue = Math.abs(hash) % 360;
  const color = `hsl(${hue}, 70%, 40%)`;
  const bgColor = `hsl(${hue}, 70%, 90%)`;
  
  return L.divIcon({
    className: 'custom-marker',
    html: `<div style="
      width: 32px; 
      height: 32px; 
      border-radius: 50%; 
      background-color: ${bgColor}; 
      border: 2px solid ${color}; 
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: ${color};
    ">👤</div>`,
    iconSize: [32, 32],
    iconAnchor: [16, 16]
  });
};

const createYesNoHouseholdIcon = (prefix, parentKey, childKey) => {
  // Generate unique color based on the combination
  const uniqueString = `${prefix}_${parentKey}_${childKey}`;
  let hash = 0;
  
  for (let i = 0; i < uniqueString.length; i++) {
    hash = uniqueString.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  const hue = Math.abs(hash) % 360;
  const color = `hsl(${hue}, 70%, 40%)`;
  const bgColor = `hsl(${hue}, 70%, 90%)`;
  
  return L.divIcon({
    className: 'custom-marker',
    html: `<div style="
      width: 32px; 
      height: 32px; 
      border-radius: 50%; 
      background-color: ${bgColor}; 
      border: 2px solid ${color}; 
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: ${color};
    ">🏠</div>`,
    iconSize: [32, 32],
    iconAnchor: [16, 16]
  });
};


  

  // Update the shouldShowMarker function
 const shouldShowMarker = (item, dataType = null) => {
  // Check location filtering first
  const itemVillage = item.fld_village_name;

  if (selectedVillages.length > 0 && !selectedVillages.includes(itemVillage)) {
    return false;
  }

  if (selectedTaluks.length > 0) {
    const talukVillages = selectedTaluks.flatMap(taluk => talukVillageData[taluk] || []);
    if (!talukVillages.includes(itemVillage)) {
      return false;
    }
  }

  // Apply age and gender filters ONLY for health status data
  if (dataType === 'healthStatus') {
    // Check if any age filters are active
    const hasActiveAgeFilters = Object.values(activeAgeFilters).some(active => active);
    if (hasActiveAgeFilters && item.fld_age_years) {
      const ageGroup = getAgeGroup(item.fld_age_years);
      if (ageGroup && !activeAgeFilters[ageGroup]) {
        return false;
      }
    }

    // Check if any gender filters are active
    const hasActiveGenderFilters = Object.values(activeGenderFilters).some(active => active);
    if (hasActiveGenderFilters && item.fld_gender_name) {
      if (!activeGenderFilters[item.fld_gender_name]) {
        return false;
      }
    }
  }

  return true;
};

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);



  const getFacilityCounts = () => {
    if (!mapData) return {};

    const facilityCounts = {
      education: 0,
      healthcare: 0,
      water: 0,
      community: 0,
      transport: 0,
      waste: 0,
      market: 0,
      religious: 0,
      recreation: 0
    };

    const mapTypes = {
      education: mapData.levels_of_education,
      healthcare: mapData.healthcare_delivery_systems,
      water: mapData.water_source,
      community: mapData.community_facilities,
      transport: mapData.Transportation,
      waste: mapData.waste_management_facility,
      market: mapData.market_fruits_and_vegetable_meat_and_poultry,
      religious: mapData.religious_places,
      recreation: mapData.recreational_entertainment
    };

    Object.entries(mapTypes).forEach(([key, items]) => {
      if (Array.isArray(items)) {
        facilityCounts[key] = items.filter(item => shouldShowMarker(item)).length;
      }
    });

    return facilityCounts;
  };

  const facilityCounts = getFacilityCounts();




  const formatDataValue = (value) => {
    return value === "-999" ? "-" : value;
  };

  const addMarkersToMap = (data) => {
    const map = mapInstanceRef.current;
    if (!map) return;

    Object.values(markerClustersRef.current).forEach(cluster => {
      cluster.clearLayers();
    });

   if (filteredDeterminantData.behavioral) {
    Object.entries(filteredDeterminantData.behavioral).forEach(([parentKey, parentData]) => {
      if (typeof parentData === 'object' && parentData !== null) {
        // Get all child keys to determine which is first and which is second
        const childKeys = Object.keys(parentData);
        
        Object.entries(parentData).forEach(([childKey, items], index) => {
          const filterKey = `behavioral_${parentKey}_${childKey}`;
          if (Array.isArray(items) && activeDeterminantFilters[filterKey]) {
            items.forEach((item) => {
              if (item.fld_geo_x && item.fld_geo_y && shouldShowMarker(item)) {
                try {
                  const lat = parseFloat(item.fld_geo_x);
                  const lng = parseFloat(item.fld_geo_y);

                  if (!isNaN(lat) && !isNaN(lng) && isPointInDistrict(lat, lng)) {
                    // Use Yes/No icons for filtered behavioral data
                    const isFirstKey = index === 0;
                   const marker = L.marker([lat, lng], {
  icon: createYesNoMemberIcon('behavioral', parentKey, childKey)
});

                    marker.bindPopup(`
                      <div style="min-width: 250px;">
                        <h3 style="color:#3498db; margin-bottom: 10px;">Behavioral: ${parentKey.replace(/_/g, ' ')}</h3>
                        <p><strong>Type:</strong> ${childKey.replace(/_/g, ' ')}</p>
                      </div>
                    `, {
                      autoClose: false,
                      closeOnClick: false
                    });

                    marker.on('mouseover', function () {
                      this.openPopup();
                    });

                    marker.on('mouseout', function () {
                      this.closePopup();
                    });

                    markerClustersRef.current.education.addLayer(marker);
                  }
                } catch (error) {
                  console.error(`Error adding behavioral ${parentKey}_${childKey} marker:`, error, item);
                }
              }
            });
          }
        });
      }
    });
  }

  // Process Social Data - Use Yes/No icons for filtered data
  if (filteredDeterminantData.social) {
    Object.entries(filteredDeterminantData.social).forEach(([parentKey, parentData]) => {
      if (typeof parentData === 'object' && parentData !== null && !Array.isArray(parentData)) {
        // Get all child keys to determine which is first and which is second
        const childKeys = Object.keys(parentData);
        
        Object.entries(parentData).forEach(([childKey, items], index) => {
          const filterKey = `social_${parentKey}_${childKey}`;
          if (Array.isArray(items) && activeDeterminantFilters[filterKey]) {
            items.forEach((item) => {
              if (item.fld_geo_x && item.fld_geo_y && shouldShowMarker(item)) {
                try {
                  const lat = parseFloat(item.fld_geo_x);
                  const lng = parseFloat(item.fld_geo_y);

                  if (!isNaN(lat) && !isNaN(lng) && isPointInDistrict(lat, lng)) {
                    // Use Yes/No icons for filtered social data
                    const isFirstKey = index === 0;
                    const marker = L.marker([lat, lng], {
  icon: createYesNoHouseholdIcon('social', parentKey, childKey)
});

                    marker.bindPopup(`
                      <div style="min-width: 250px;">
                        <h3 style="color:#e74c3c; margin-bottom: 10px;">Social: ${parentKey.replace(/_/g, ' ')}</h3>
                        <p><strong>Type:</strong> ${childKey.replace(/_/g, ' ')}</p>
                      </div>
                    `, {
                      autoClose: false,
                      closeOnClick: false
                    });

                    marker.on('mouseover', function () {
                      this.openPopup();
                    });

                    marker.on('mouseout', function () {
                      this.closePopup();
                    });

                    markerClustersRef.current.community.addLayer(marker);
                  }
                } catch (error) {
                  console.error(`Error adding social ${parentKey}_${childKey} marker:`, error, item);
                }
              }
            });
          }
        });
      }
    });
  }

  if (filteredDeterminantData.health) {
  Object.entries(filteredDeterminantData.health).forEach(([parentKey, parentData], parentIndex) => {
    if (typeof parentData === 'object' && parentData !== null && !Array.isArray(parentData)) {
      Object.entries(parentData).forEach(([childKey, items], index) => {
        const filterKey = `health_${parentKey}_${childKey}`;
        if (Array.isArray(items) && activeDeterminantFilters[filterKey]) {
          items.forEach((item) => {
            if (item.fld_geo_x && item.fld_geo_y && shouldShowMarker(item, 'healthStatus')) {
              try {
                const lat = parseFloat(item.fld_geo_x);
                const lng = parseFloat(item.fld_geo_y);

                if (!isNaN(lat) && !isNaN(lng) && isPointInDistrict(lat, lng)) {
                  const isFirstKey = index === 0;
                  const marker = L.marker([lat, lng], {
  icon: createYesNoMemberIcon('health', parentKey, childKey)
});


                  marker.bindPopup(`
                    <div style="min-width: 250px;">
                      <h3 style="color:#16a085; margin-bottom: 10px;">Health Status: ${parentKey.replace(/_/g, ' ')}</h3>
                      <p><strong>Type:</strong> ${childKey.replace(/_/g, ' ')}</p>
                      ${item.fld_gender_name ? `<p><strong>Gender:</strong> ${formatDataValue(item.fld_gender_name)}</p>` : ''}
                      ${item.fld_age_years ? `<p><strong>Age:</strong> ${formatDataValue(item.fld_age_years)} years</p>` : ''}
                    </div>
                  `, {
                    autoClose: false,
                    closeOnClick: false
                  });

                  marker.on('mouseover', function () {
                    this.openPopup();
                  });

                  marker.on('mouseout', function () {
                    this.closePopup();
                  });

                  markerClustersRef.current.health.addLayer(marker);
                }
              } catch (error) {
                console.error(`Error adding health ${parentKey}_${childKey} marker:`, error, item);
              }
            }
          });
        }
      });
    }
  });
}

   if (filteredDeterminantData.environmental) {
  Object.entries(filteredDeterminantData.environmental).forEach(([parentKey, parentData]) => {
    if (typeof parentData === 'object' && parentData !== null && !Array.isArray(parentData)) {
      Object.entries(parentData).forEach(([childKey, items], index) => {
        const filterKey = `environmental_${parentKey}_${childKey}`;
        if (Array.isArray(items) && activeDeterminantFilters[filterKey]) {
          items.forEach((item) => {
            if (item.fld_geo_x && item.fld_geo_y && shouldShowMarker(item)) {
              try {
                const lat = parseFloat(item.fld_geo_x);
                const lng = parseFloat(item.fld_geo_y);

                if (!isNaN(lat) && !isNaN(lng) && isPointInDistrict(lat, lng)) {
                  const isFirstKey = index === 0;
                 const marker = L.marker([lat, lng], {
  icon: createYesNoHouseholdIcon('environmental', parentKey, childKey)
});

                  marker.bindPopup(`
                    <div style="min-width: 250px;">
                      <h3 style="color:#27ae60; margin-bottom: 10px;">Environmental: ${parentKey.replace(/_/g, ' ')}</h3>
                      <p><strong>Type:</strong> ${childKey.replace(/_/g, ' ')}</p>
                    </div>
                  `, {
                    autoClose: false,
                    closeOnClick: false
                  });

                  marker.on('mouseover', function () {
                    this.openPopup();
                  });

                  marker.on('mouseout', function () {
                    this.closePopup();
                  });

                  markerClustersRef.current.environmental.addLayer(marker);
                }
              } catch (error) {
                console.error(`Error adding environmental ${parentKey}_${childKey} marker:`, error, item);
              }
            }
          });
        }
      });
    }
  });
}


   if (filteredDeterminantData.healthService) {
  Object.entries(filteredDeterminantData.healthService).forEach(([parentKey, parentData]) => {
    if (typeof parentData === 'object' && parentData !== null && !Array.isArray(parentData)) {
      Object.entries(parentData).forEach(([childKey, items], index) => {
        const filterKey = `healthService_${parentKey}_${childKey}`;
        if (Array.isArray(items) && activeDeterminantFilters[filterKey]) {
          items.forEach((item) => {
            if (item.fld_geo_x && item.fld_geo_y && shouldShowMarker(item)) {
              try {
                const lat = parseFloat(item.fld_geo_x);
                const lng = parseFloat(item.fld_geo_y);

                if (!isNaN(lat) && !isNaN(lng) && isPointInDistrict(lat, lng)) {
                  const isFirstKey = index === 0;
                 const marker = L.marker([lat, lng], {
  icon: createYesNoHouseholdIcon('healthService', parentKey, childKey)
});

                  marker.bindPopup(`
                    <div style="min-width: 250px;">
                      <h3 style="color:#e74c3c; margin-bottom: 10px;">Health Service: ${parentKey.replace(/_/g, ' ')}</h3>
                      <p><strong>Type:</strong> ${childKey.replace(/_/g, ' ')}</p>
                    </div>
                  `, {
                    autoClose: false,
                    closeOnClick: false
                  });

                  marker.on('mouseover', function () {
                    this.openPopup();
                  });

                  marker.on('mouseout', function () {
                    this.closePopup();
                  });

                  markerClustersRef.current.healthService.addLayer(marker);
                }
              } catch (error) {
                console.error(`Error adding healthService ${parentKey}_${childKey} marker:`, error, item);
              }
            }
          });
        }
      });
    }
  });
}

    const icons = {
      education: createCustomIcon('🎓'),
      healthcare: createCustomIcon('🏥'),
      water: createCustomIcon('💧'),
      community: createCustomIcon('🏛️'),
      transport: createCustomIcon('🚌'),
      waste: createCustomIcon('🗑️'),
      market: createCustomIcon('🛒'),
      religious: createCustomIcon('🕌'),
      recreation: createCustomIcon('🎭')
    };

    const createPopupContent = (item, type) => {
      switch (type) {
        case 'education':
          return `
            <div style="min-width: 250px;">
              <h3 style="color:#3498db; margin-bottom: 10px;">🎓 Educational Institution</h3>
              <p><strong>Level:</strong> ${formatDataValue(item.fld_levels_of_education_name)}</p>
              <p><strong>Type:</strong> ${formatDataValue(item.fld_type_edu_inst_name)}</p>
              <p><strong>Name:</strong> ${formatDataValue(item.fld_name_of_edu_institution)}</p>
              <p><strong>Village:</strong> ${formatDataValue(item.fld_village_name)}</p>
            </div>
          `;
        case 'healthcare':
          return `
            <div style="min-width: 250px;">
              <h3 style="color:#e74c3c; margin-bottom: 10px;">🏥 Healthcare Facility</h3>
              <p><strong>Health Care Delivery System:</strong> ${formatDataValue(item.fld_health_care_delivery_sys_name)}</p>
              <p><strong>Type of Govt Hospital:</strong> ${formatDataValue(item.fld_govt_hospital_type_name)}</p>
              <p><strong>Name of Health Care Center:</strong> ${formatDataValue(item.fld_name_of_healthcare_center)}</p>
              <p><strong>Doctors:</strong> ${formatDataValue(item.fld_num_doctor)}</p>
              <p><strong>Nurses:</strong> ${formatDataValue(item.fld_num_nurse)}</p>
              <p><strong>ANM:</strong> ${formatDataValue(item.fld_num_anm)}</p>
              <p><strong>ASHA:</strong> ${formatDataValue(item.fld_num_asha)}</p>
              <p><strong>Details of Services:</strong> ${formatDataValue(item.fld_details_of_service_name)}</p>
              <p><strong>Any Other Specify:</strong> ${formatDataValue(item.fld_any_other_specify)}</p>
              <p><strong>Village:</strong> ${formatDataValue(item.fld_village_name)}</p>
            </div>
          `;
        case 'water':
          return `
            <div style="min-width: 250px;">
              <h3 style="color:#2980b9; margin-bottom: 10px;">💧 Water Source</h3>
              <p><strong>Type:</strong> ${formatDataValue(item.fld_water_source_type_name)}</p>
              <p><strong>Quality:</strong> ${formatDataValue(item.fld_water_quality_parameter)}</p>
              <p><strong>Village:</strong> ${formatDataValue(item.fld_village_name)}</p>
            </div>
          `;
        case 'community':
          return `
            <div style="min-width: 250px;">
              <h3 style="color:#27ae60; margin-bottom: 10px;">🏛️ Community Facility</h3>
              <p><strong>Type:</strong> ${formatDataValue(item.fld_community_facility_type_name)}</p>
              <p><strong>Name:</strong> ${formatDataValue(item.fld_community_facility_name)}</p>
              <p><strong>Village:</strong> ${formatDataValue(item.fld_village_name)}</p>
            </div>
          `;
        case 'transport':
          return `
            <div style="min-width: 250px;">
              <h3 style="color:#f39c12; margin-bottom: 10px;">🚌 Transportation</h3>
              <p><strong>Type:</strong> ${formatDataValue(item.fld_transportation_type_name)}</p>
              <p><strong>Name:</strong> ${formatDataValue(item.fld_transportation_name)}</p>
              <p><strong>Village:</strong> ${formatDataValue(item.fld_village_name)}</p>
            </div>
          `;
        case 'waste':
          return `
            <div style="min-width: 250px;">
              <h3 style="color:#7f8c8d; margin-bottom: 10px;">🗑️ Waste Management</h3>
              <p><strong>Type:</strong> ${formatDataValue(item.fld_waste_managment_type_name)}</p>
              <p><strong>Name:</strong> ${formatDataValue(item.fld_waste_managment_name)}</p>
              <p><strong>Village:</strong> ${formatDataValue(item.fld_village_name)}</p>
            </div>
          `;
        case 'market':
          return `
            <div style="min-width: 250px;">
              <h3 style="color:#d35400; margin-bottom: 10px;">🛒 Market</h3>
              <p><strong>Area:</strong> ${formatDataValue(item.fld_mar_fruit_veg_meat_pltry_area)}</p>
              <p><strong>Village:</strong> ${formatDataValue(item.fld_village_name)}</p>
            </div>
          `;
        case 'religious':
          return `
            <div style="min-width: 250px;">
              <h3 style="color:#8e44ad; margin-bottom: 10px;">🕌 Religious Place</h3>
              <p><strong>Type:</strong> ${formatDataValue(item.fld_relegious_place_type_name)}</p>
              <p><strong>Village:</strong> ${formatDataValue(item.fld_village_name)}</p>
            </div>
          `;
        case 'recreation':
          return `
            <div style="min-width: 250px;">
              <h3 style="color:#e67e22; margin-bottom: 10px;">🎭 Recreation & Entertainment</h3>
              <p><strong>Type:</strong> ${formatDataValue(item.fld_recreat_entertainmnt_type_name)}</p>
              <p><strong>Name:</strong> ${formatDataValue(item.fld_recreat_entertainmnt_name)}</p>
              <p><strong>Village:</strong> ${formatDataValue(item.fld_village_name)}</p>
            </div>
          `;
        default:
          return `<div>No information available</div>`;
      }
    };

    const addMarkers = (items, type, iconType) => {
      if (!Array.isArray(items) || !activeFilters[type]) return;

      items.forEach((item) => {
        if (item.fld_geo_x && item.fld_geo_y && shouldShowMarker(item)) {
          try {
            const lat = parseFloat(item.fld_geo_x);
            const lng = parseFloat(item.fld_geo_y);

            if (!isNaN(lat) && !isNaN(lng)) {
              const marker = L.marker([lat, lng], {
                icon: icons[iconType]
              });

              marker.bindPopup(createPopupContent(item, type), {
                autoClose: false,
                closeOnClick: false
              });

              marker.on('mouseover', function () {
                this.openPopup();
              });

              marker.on('mouseout', function () {
                this.closePopup();
              });

              markerClustersRef.current[type].addLayer(marker);
            }
          } catch (error) {
            console.error(`Error adding ${type} marker:`, error, item);
          }
        }
      });
    };

    // Add all types of markers
    addMarkers(data.levels_of_education, 'education', 'education');
    addMarkers(data.healthcare_delivery_systems, 'healthcare', 'healthcare');
    addMarkers(data.water_source, 'water', 'water');
    addMarkers(data.community_facilities, 'community', 'community');
    addMarkers(data.Transportation, 'transport', 'transport');
    addMarkers(data.waste_management_facility, 'waste', 'waste');
    addMarkers(data.market_fruits_and_vegetable_meat_and_poultry, 'market', 'market');
    addMarkers(data.religious_places, 'religious', 'religious');
    addMarkers(data.recreational_entertainment, 'recreation', 'recreation');
  };

  const handleFilterChange = (filterName) => {
    setActiveFilters(prev => ({
      ...prev,
      [filterName]: !prev[filterName]
    }));
  };

  return (
    <div className="dashboard-section-container">

      {(isLoading) && (
        <div className="loading-overlay">
          <ProgressSpinner className='progressBar' />
        </div>
      )}

      {/* Facility Filters Dropdown */}
      <div className={`filters-dropdown ${showFilters ? 'active' : ''}`}>
        <Button
          label={`Facility Filters ${showFilters ? '-' : '+'}`}
          className="p-button-text p-button-plain filters-toggle-button"
          onClick={toggleFilters}
        />

        <div className="filters-dropdown-content">
          <div className="filter-buttons-container">
            <button
              className="filter-button select-all"
              onClick={selectAllFacilityFilters}
            >
              Select All
            </button>
            <button
              className="filter-button remove-all"
              onClick={removeAllFacilityFilters}
            >
              Remove All
            </button>
          </div>

          {Object.entries({
            education: '🎓 Education',
            healthcare: '🏥 Healthcare',
            water: '💧 Water',
            community: '🏛️ Community',
            transport: '🚌 Transport',
            waste: '🗑️ Waste',
            market: '🛒 Market',
            religious: '🕌 Religious',
            recreation: '🎭 Recreation'
          }).map(([key, label]) => (
            <div key={key} className="filter-item">
              <input
                type="checkbox"
                className="filter-checkbox"
                checked={activeFilters[key]}
                onChange={() => handleFilterChange(key)}
              />
              <span className="filter-icon">{label.split(' ')[0]}</span>
              <span className="filter-label">{label.split(' ').slice(1).join(' ')}</span>
              <span className="filter-count" style={{ marginLeft: '8px', color: '#555' }}>
                ({facilityCounts[key] || 0})
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Location Filters Dropdown */}
      <div className={`filters-dropdown location-filters ${showFilters ? 'pushed-down' : ''} ${showLocationFilters ? 'active' : ''}`}>
        <Button
          label={`Location Filters ${showLocationFilters ? '-' : '+'}`}
          className="p-button-text p-button-plain filters-toggle-button"
          onClick={toggleLocationFilters}
        />

        <div className="filters-dropdown-content location-dropdown">
          {(selectedTaluks.length > 0 || selectedVillages.length > 0) && (
            <div className="location-filter-header">
              <Button
                label="Clear All"
                className="p-button-text p-button-sm clear-location-button"
                onClick={clearLocationFilters}
              />
            </div>
          )}

          {/* Taluk Selection */}
          <div className="taluk-section">
            <h4 className="filter-section-title">📍 Select Taluks:</h4>
            <div className="taluk-options">
              {Object.keys(talukVillageData).map((taluk) => (
                <div key={taluk} className="filter-item">
                  <input
                    type="checkbox"
                    className="filter-checkbox"
                    checked={selectedTaluks.includes(taluk)}
                    onChange={() => handleTalukChange(taluk)}
                  />
                  <span className="filter-label">{taluk}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Village Selection */}
          {selectedTaluks.length > 0 && (
            <div className="village-section">
              {/* <h4 className="filter-section-title">🏘️ Select Villages:</h4> */}

              {/* Village Search Bar */}
              <div className="village-search">
                <InputText
                  value={villageSearchTerm}
                  onChange={(e) => setVillageSearchTerm(e.target.value)}
                  placeholder="Search villages... 🏘️"
                  className="village-search-input"
                />
                {villageSearchTerm && (
                  <button
                    className="clear-search"
                    onClick={() => setVillageSearchTerm('')}
                    aria-label="Clear search"
                  >
                    ×
                  </button>
                )}
              </div>

              <div className="village-options">
                {filteredVillages.map((village) => (
                  <div key={village} className="filter-item">
                    <input
                      type="checkbox"
                      className="filter-checkbox"
                      checked={selectedVillages.includes(village)}
                      onChange={() => handleVillageChange(village)}
                    />
                    <span className="filter-label">{village}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Selected Summary */}
          {(selectedTaluks.length > 0 || selectedVillages.length > 0) && (
            <div className="selection-summary">
              <h5 style={{ color: '#ff6b6b' }}>Current Selection:</h5>
              {selectedTaluks.length > 0 && (
                <h5><strong>Taluks:</strong> {selectedTaluks.join(', ')}</h5>
              )}
              {selectedVillages.length > 0 && (
                <div>
                  <h5><strong>Villages:</strong></h5>
                  <div className="selected-villages-list">
                    {selectedVillages.map(village => (
                      <span className="selected-village-item" key={village}>
                        {village}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>


      {!showFilters && !showLocationFilters && (
        <div className={`filters-dropdown determinant-filters ${showDeterminantFilters ? 'active' : ''}`}>
          <Button
            label={`Determinant Filters ${showDeterminantFilters ? '-' : '+'}`}
            className="p-button-text p-button-plain filters-toggle-button"
            onClick={toggleDeterminantFilters}
          />

          <div className="filters-dropdown-content" style={{ maxHeight: '450px', overflowY: 'auto' }}>
            {/* Search Bar */}
            <div className="village-search">
              <InputText
                value={determinantSearchTerm}
                onChange={(e) => setDeterminantSearchTerm(e.target.value)}
                placeholder="Search determinants..."
                className="village-search-input"
              />
              {determinantSearchTerm && (
                <button
                  className="clear-search"
                  onClick={() => setDeterminantSearchTerm('')}
                  aria-label="Clear search"
                >
                  ×
                </button>
              )}
            </div>

            <div className="filter-buttons-container">
              <button
                className="filter-button select-all"
                onClick={selectAllDeterminantFilters}
              >
                Select All
              </button>
              <button
                className="filter-button remove-all"
                onClick={removeAllDeterminantFilters}
              >
                Remove All
              </button>
            </div>

            {/* Social Determinants Section */}
            {filteredDeterminantData.social && filterDeterminantOptionsWithoutYesNo(filteredDeterminantData.social, 'social').length > 0 && (
              <div className="determinant-section">
                <div
                  className="determinant-section-header"
                  onClick={() => toggleDeterminantSection('social')}
                >
                  <h4 className="filter-section-title">Social determinants</h4>
                  <span className="expand-collapse-icon">
                    {expandedDeterminantSections.social ? '−' : '+'}
                  </span>
                </div>
                {expandedDeterminantSections.social && (
                  <div className="determinant-section-content">
                    {filterDeterminantOptionsWithoutYesNo(filteredDeterminantData.social, 'social').map((parentKey) => (
                      <div key={`social_${parentKey}`} className="determinant-subsection">
                        <div
                          className="determinant-section-header"
                          onClick={() => toggleNestedDeterminantSection(`social_${parentKey}`)}
                        >
                          <h5 className="filter-section-title">{parentKey.replace(/_/g, ' ')}</h5>
                          <span className="expand-collapse-icon">
                            {expandedDeterminantSections[`social_${parentKey}`] ? '−' : '+'}
                          </span>
                        </div>
                        {expandedDeterminantSections[`social_${parentKey}`] && filteredDeterminantData.social[parentKey] && typeof filteredDeterminantData.social[parentKey] === 'object' && (
                          <div className="determinant-section-content">
                            {renderDeterminantOptions(filteredDeterminantData.social, parentKey, 'social')}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}


            {/* Behavioral Determinants Section */}
            {filteredDeterminantData.behavioral && filterDeterminantOptionsWithoutYesNo(filteredDeterminantData.behavioral, 'behavioral').length > 0 && (
              <div className="determinant-section">
                <div
                  className="determinant-section-header"
                  onClick={() => toggleDeterminantSection('behavioral')}
                >
                  <h4 className="filter-section-title">Behavioural and cultural determinants</h4>
                  <span className="expand-collapse-icon">
                    {expandedDeterminantSections.behavioral ? '−' : '+'}
                  </span>
                </div>
                {expandedDeterminantSections.behavioral && (
                  <div className="determinant-section-content">
                    {filterDeterminantOptionsWithoutYesNo(filteredDeterminantData.behavioral, 'behavioral').map((parentKey) => (
                      <div key={`behavioral_${parentKey}`} className="determinant-subsection">
                        <div
                          className="determinant-section-header"
                          onClick={() => toggleNestedDeterminantSection(`behavioral_${parentKey}`)}
                        >
                          <h5 className="filter-section-title">{parentKey.replace(/_/g, ' ')}</h5>
                          <span className="expand-collapse-icon">
                            {expandedDeterminantSections[`behavioral_${parentKey}`] ? '−' : '+'}
                          </span>
                        </div>
                        {expandedDeterminantSections[`behavioral_${parentKey}`] && filteredDeterminantData.behavioral[parentKey] && typeof filteredDeterminantData.behavioral[parentKey] === 'object' && (
                          <div className="determinant-section-content">
                                 {renderDeterminantOptions(filteredDeterminantData.behavioral, parentKey, 'behavioral')}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* Health Status Determinants Section */}
            {filteredDeterminantData.health && filterDeterminantOptionsWithoutYesNo(filteredDeterminantData.health, 'health').length > 0 && (
              <div className="determinant-section">
                <div
                  className="determinant-section-header"
                  onClick={() => toggleDeterminantSection('health')}
                >
                  <h4 className="filter-section-title">Health Status</h4>
                  <span className="expand-collapse-icon">
                    {expandedDeterminantSections.health ? '−' : '+'}
                  </span>
                </div>
                {expandedDeterminantSections.health && (
                  <div className="determinant-section-content">
                    {filterDeterminantOptionsWithoutYesNo(filteredDeterminantData.health, 'health').map((parentKey) => (
                      <div key={`health_${parentKey}`} className="determinant-subsection">
                        <div
                          className="determinant-section-header"
                          onClick={() => toggleNestedDeterminantSection(`health_${parentKey}`)}
                        >
                          <h5 className="filter-section-title">{parentKey.replace(/_/g, ' ')}</h5>
                          <span className="expand-collapse-icon">
                            {expandedDeterminantSections[`health_${parentKey}`] ? '−' : '+'}
                          </span>
                        </div>
                        {expandedDeterminantSections[`health_${parentKey}`] && filteredDeterminantData.health[parentKey] && typeof filteredDeterminantData.health[parentKey] === 'object' && (
                          <div className="determinant-section-content">
                            { renderDeterminantOptions(filteredDeterminantData.health, parentKey, 'health')}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}


            {filteredDeterminantData.environmental && filterDeterminantOptionsWithoutYesNo(filteredDeterminantData.environmental, 'environmental').length > 0 && (
              <div className="determinant-section">
                <div
                  className="determinant-section-header"
                  onClick={() => toggleDeterminantSection('environmental')}
                >
                  <h4 className="filter-section-title">Environmental Determinants</h4>
                  <span className="expand-collapse-icon">
                    {expandedDeterminantSections.environmental ? '−' : '+'}
                  </span>
                </div>
                {expandedDeterminantSections.environmental && (
                  <div className="determinant-section-content">
                    {filterDeterminantOptionsWithoutYesNo(filteredDeterminantData.environmental, 'environmental').map((parentKey) => (
                      <div key={`environmental_${parentKey}`} className="determinant-subsection">
                        <div
                          className="determinant-section-header"
                          onClick={() => toggleNestedDeterminantSection(`environmental_${parentKey}`)}
                        >
                          <h5 className="filter-section-title">{parentKey.replace(/_/g, ' ')}</h5>
                          <span className="expand-collapse-icon">
                            {expandedDeterminantSections[`environmental_${parentKey}`] ? '−' : '+'}
                          </span>
                        </div>
                        {expandedDeterminantSections[`environmental_${parentKey}`] && filteredDeterminantData.environmental[parentKey] && typeof filteredDeterminantData.environmental[parentKey] === 'object' && (
                          <div className="determinant-section-content">
                            {renderDeterminantOptions(filteredDeterminantData.environmental, parentKey, 'environmental')}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {filteredDeterminantData.healthService && filterDeterminantOptionsWithoutYesNo(filteredDeterminantData.healthService, 'healthService').length > 0 && (
              <div className="determinant-section">
                <div
                  className="determinant-section-header"
                  onClick={() => toggleDeterminantSection('healthService')}
                >
                  <h4 className="filter-section-title">Health Service Determinants</h4>
                  <span className="expand-collapse-icon">
                    {expandedDeterminantSections.healthService ? '−' : '+'}
                  </span>
                </div>
                {expandedDeterminantSections.healthService && (
                  <div className="determinant-section-content">
                    {filterDeterminantOptionsWithoutYesNo(filteredDeterminantData.healthService, 'healthService').map((parentKey) => (
                      <div key={`healthService_${parentKey}`} className="determinant-subsection">
                        <div
                          className="determinant-section-header"
                          onClick={() => toggleNestedDeterminantSection(`healthService_${parentKey}`)}
                        >
                          <h5 className="filter-section-title">{parentKey.replace(/_/g, ' ')}</h5>
                          <span className="expand-collapse-icon">
                            {expandedDeterminantSections[`healthService_${parentKey}`] ? '−' : '+'}
                          </span>
                        </div>
                        {expandedDeterminantSections[`healthService_${parentKey}`] && filteredDeterminantData.healthService[parentKey] && typeof filteredDeterminantData.healthService[parentKey] === 'object' && (
                          <div className="determinant-section-content">
                            {renderDeterminantOptions(filteredDeterminantData.healthService, parentKey, 'healthService')}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

          {!determinantSearchTerm || shouldShowAgeGenderSections() ? (
            <div className="determinant-section">
              <div
                className="determinant-section-header"
                onClick={() => toggleDeterminantSection('age')}
              >
                <h4 className="filter-section-title">Age Filters (Health Status)</h4>
                <span className="expand-collapse-icon">
                  {expandedDeterminantSections.age ? '−' : '+'}
                </span>
              </div>
              {expandedDeterminantSections.age && (
                <div className="determinant-section-content">
                  <div className="filter-buttons-container">
                    <button
                      className="filter-button select-all"
                      onClick={selectAllAgeFilters}
                    >
                      Select All
                    </button>
                    <button
                      className="filter-button remove-all"
                      onClick={removeAllAgeFilters}
                    >
                      Remove All
                    </button>
                  </div>

                  {Object.entries({
                    "0-5": "0-5 years",
                    "6-14": "6-14 years",
                    "15-19": "15-19 years",
                    "20-29": "20-29 years",
                    "30-39": "30-39 years",
                    "40-49": "40-49 years",
                    "50-59": "50-59 years",
                    "60+": "60+ years"
                  }).map(([key, label]) => (
                    <div key={key} className="filter-item">
                      <input
                        type="checkbox"
                        className="filter-checkbox"
                        checked={activeAgeFilters[key]}
                        onChange={() => handleAgeFilterChange(key)}
                      />
                      <span className="filter-label">{label}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            ) : null}
             
             {!determinantSearchTerm || shouldShowAgeGenderSections() ? (
            <div className="determinant-section">
              <div
                className="determinant-section-header"
                onClick={() => toggleDeterminantSection('gender')}
              >
                <h4 className="filter-section-title">Gender Filters (Health Status)</h4>
                <span className="expand-collapse-icon">
                  {expandedDeterminantSections.gender ? '−' : '+'}
                </span>
              </div>
              {expandedDeterminantSections.gender && (
                <div className="determinant-section-content">
                  <div className="filter-buttons-container">
                    <button
                      className="filter-button select-all"
                      onClick={selectAllGenderFilters}
                    >
                      Select All
                    </button>
                    <button
                      className="filter-button remove-all"
                      onClick={removeAllGenderFilters}
                    >
                      Remove All
                    </button>
                  </div>

                  {Object.entries({
                    "Male": "Male",
                    "Female": "Female"
                  }).map(([key, label]) => (
                    <div key={key} className="filter-item">
                      <input
                        type="checkbox"
                        className="filter-checkbox"
                        checked={activeGenderFilters[key]}
                        onChange={() => handleGenderFilterChange(key)}
                      />
                      <span className="filter-label">{label}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            ) : null}


            {/* Show message when no results found */}
            {determinantSearchTerm &&
              filterDeterminantOptionsWithoutYesNo (filteredDeterminantData.social, 'social').length === 0 &&
              filterDeterminantOptionsWithoutYesNo (filteredDeterminantData.behavioral, 'behavioral').length === 0 &&
              filterDeterminantOptionsWithoutYesNo (filteredDeterminantData.health, 'health').length === 0 &&
              filterDeterminantOptionsWithoutYesNo (filteredDeterminantData.environmental, 'environmental').length === 0 &&
              filterDeterminantOptionsWithoutYesNo (filteredDeterminantData.healthService, 'healthService').length === 0 && (
                <div className="no-results">
                  No determinants found matching "{determinantSearchTerm}"
                </div>
              )}

          </div>
        </div>)}
      <div ref={mapRef} className="map-container" />
    </div>
  );
};

export default DashboardSection;